import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import { IButton } from 'src/common/interfaces/IButton';
import NumberInputField from 'src/number-input-field';
import Pagination from 'src/pagination/pagination';
import { styles } from './search-products-bottom-control-styles';

const SearchProductsBottomControl: React.FC<ISearchProductsBottomControlProps> = ({
  currentPage,
  lastPage,
  quantity,
  quantityVisible,
  submitButton,
  onQuantityChange,
  nextPage,
  previousPage,
}: ISearchProductsBottomControlProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  const handleQuantityChange = (value: number): void => {
    onQuantityChange(value);
  };
  const onPageChanged = (updatedPage: number): void => {
    if (updatedPage > currentPage) {
      nextPage();
    } else {
      previousPage();
    }
  };

  return (
    <Grid container justifyContent='space-between'>
      <Grid item>
        <Grid container justifyContent='center' className='fullHeight'>
          <Pagination
            currentPage={currentPage}
            totalPages={lastPage}
            updateCurrentPageHandler={onPageChanged}
            testIdPrefix={'search-products'}
          />
        </Grid>
      </Grid>
      <Grid
        item
        container
        justifyContent='center'
        className={classes.bottomRightButtons}
        wrap='nowrap'
      >
        {quantityVisible && (
          <>
            <Grid item>
              <Box className={classes.quantityLabel}>{t('QtyButtonLabel')}</Box>
            </Grid>
            <Grid item className={classes.quantityGrid}>
              <NumberInputField
                value={quantity}
                minimum={1}
                handleChange={handleQuantityChange}
                disabled={submitButton.disabled}
              />
            </Grid>
          </>
        )}
        <Grid item className={classes.buttonGrid}>
          <BaseButton
            data-testid='search-submit-btn'
            className={classes.addButton}
            disabled={submitButton.disabled}
            onClick={() => submitButton.onClick()}
          >
            {submitButton.label}
          </BaseButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface ISearchProductsBottomControlProps {
  currentPage: number;
  lastPage: number;
  quantity: number;
  quantityVisible: boolean;
  submitButton: IButton;
  onQuantityChange: (quantity: number) => void;
  nextPage: () => void;
  previousPage: () => void;
}

export default SearchProductsBottomControl;
